export default "__VITE_ASSET__56c3cb44__"